import { message } from 'antd'
import api from 'api'
import AppDialog from 'components/AppDialog'
import { AppForm } from 'components/AppFormLayout/AppForm'
import React, { useState } from 'react'

import { FormTabsData } from './ParamGroupEditData'

interface Props {
	mode?: number
	id?: number
	customerData?: any
	afterSave?: () => void
	scope?: any
	application?: any
	type?: number
}

export const ParamGroupEdit = (props: Props) => {
	const [formData, setFormData] = useState({} as any)
	const appFormRef = React.useRef()

	const saveParamGroup = async () => {
		if (typeof appFormRef.current === 'undefined') {
			return
		}
		let paramType = props.type ? props.type : 0
		// tslint:disable-next-line: no-shadowed-variable
		let formData = (appFormRef.current as any).getFormData()
		let paramGroup = Object.assign(
			props.customerData
				? props.customerData
				: {
						application: props.application,
				  },
			formData
		)
		let res =
			paramType === 0
				? await api.modeling.param.saveParamGroup(paramGroup)
				: await api.modeling.param.saveConfigParamGroup(paramGroup)
		if (res.result) {
			message.success('保存成功！')
			close()
			props.afterSave && props.afterSave()
		} else {
			message.error(res.msg)
		}
	}

	const close = () => {
		AppDialog.close()
	}

	const FormActionData = [
		{ title: '保存', id: 'btnSave', type: 'primary', action: saveParamGroup },
		{ title: '取消', id: 'btnCancel', type: 'default', action: close },
	]

	return (
		<AppForm
			defaultTabId={0}
			appFormTabList={FormTabsData}
			appFormActionList={FormActionData}
			mode={props.mode}
			ref={appFormRef}
			customerData={props.customerData}
		></AppForm>
	)
}



// WEBPACK FOOTER //
// ./src/modules/modeling/param/components/ParamGroupEdit.tsx